function Favorites() {
	var self = this;
	this.handleProjectLikes();
	this.handleLoggedOutLikes();
	var request;
}

Favorites.prototype.handleLoggedOutLikes = function(login) {
	var self = this;
	if (!userLoggedIn && !login && window.location.pathname == "/profiles/favorites") {
		
		var likes = JSON.parse(localStorage.getItem('projectLikes'));
		likes = $.extend(true,likes,self.recentLikes);
		
		var showpos = '';
		
		$.each(likes, function(i, v) {
			if (v) {
				showpos += i+',';
			}
		});
		
		if (typeof request !== 'undefined')
			request.abort();
		request = $.ajax({
			url: '/profiles/favorites?showpos='+showpos,
			method: "GET",
			success: function(msg) {
				var data = $(msg);
				var items = data.find('.favorites-content').html();
				if (data.find('.catalogue-item').length) {
					$('.favorites-content').html(items);
					self.toggleProjectsHeart();
					self.handleProjectLikes();
				} else {
					$('.favorites-empty').addClass('-active');
				}
			}
		});
	}
};

Favorites.prototype.sendLikesRequest = function(login) {
	var self = this;
	if (userLoggedIn && (!isEmptyObject(self.recentLikes)) || window.location.pathname == "/profiles/panel") {
		if (typeof request !== 'undefined')
			request.abort();
		request = $.ajax({
			url: '/profiles/addLikes',
			timeout: 5000,
			method: "POST",
			data: self.recentLikes,
			success: function(msg) {
				localStorage.removeItem('recentLikes');
				localStorage.projectLikes = msg;
				self.recentLikes = {};
				self.projectLikes = JSON.parse(localStorage.getItem('projectLikes')) || {};
				self.toggleProjectsHeart();
				// if (login) {
				// 	self.handleLikesCount(self.projectLikes);
				// }
				self.handleLikesCount(self.projectLikes);
			}
		});
	}
};

Favorites.prototype.toggleProjectsHeart = function() {
	var self = this;
	$(".cart .cart-positions-table-body").find(".cart-positions-table-row").each(function(index, elem) {
		var item = $(elem);
		
		if (self.projectLikes[item.attr('data-id')]) {
			item.addClass('like-active');
		} else {
			item.removeClass('like-active');
		}
	});
	$(".product").each(function(index, elem) {
		var item = $(elem);
		
		if (self.projectLikes[item.attr('data-id')]) {
			item.addClass('like-active');
		} else {
			item.removeClass('like-active');
		}
	});
	$(".catalogue-item-icons__icon-heart").each(function(index, elem){
		var item = $(elem);
		var parent = item.closest('.catalogue-item');
		if (self.projectLikes[item.closest('.catalogue-item').attr('data-id')]) {
			item.addClass('active');
		} else {
			item.removeClass('active');
			// if (parent.attr('data-action')) {
			// 	if (parent.siblings(':visible').length) {
			// 		parent.fadeOut(300,function() {
			// 			if ($(this).siblings(':visible').length === 0)
			// 				$(this).closest('section.favorites').remove();
			// 			$(this).remove();

			// 		});
			// 		for (i=0;i<self.carousel.carousels.length;i++) {
			// 			var swiper = self.carousel.carousels[i];
			// 			swiper.reInit();
			// 		}
			// 	} else {
			// 		item.closest('section.favorites').fadeOut(300,function() {$(this).remove();});
			// 	}
			// }
		}
	});
};

Favorites.prototype.handleProjectLikes = function(login) {
	var self = this;
	if (localStorage.getItem('recentLikes'))
		self.recentLikes = JSON.parse(localStorage.getItem('recentLikes'));
	else
		self.recentLikes = {};
	// if ($('header[data-favorites]').length)
	// 	localStorage.projectLikes = $('header').attr('data-favorites');
	if (localStorage.getItem('projectLikes'))
		self.projectLikes = JSON.parse(localStorage.getItem('projectLikes'));
	else
		self.projectLikes = {};

	self.projectLikes = $.extend(true,self.projectLikes,self.recentLikes);
	
	self.sendLikesRequest(login);

	self.handleLikesCount(self.projectLikes);

	$(".product-like").on('click keydown', function(e) {
		if (e.type === 'keydown' && (e.key == 'Enter' || e.keyCode === 32 ) || e.type === 'click') {
			e.preventDefault();
			var id = $(this).closest('.product').attr('data-id');
			if ($(this).closest('.product').hasClass('like-active')) {
				$(this).closest('.product').removeClass('like-active');
				self.recentLikes[id] = false;
			} else {
				$(this).closest('.product').addClass('like-active');
				self.recentLikes[id] = true;
			}

			localStorage.recentLikes = JSON.stringify(self.recentLikes);
			if (!userLoggedIn) {
				if (!localStorage.lastLikeNotice || self.time.getTime()-localStorage.lastLikeNotice > 24*3600*100) {
					// $('body').append("<div class='header-dialog'><b>Aby wyświetlić ulubione projekty musisz się zalogować.</b> Twoje preferencje zostaną zapamiętane do tego czasu.</div>");
					// self.handleHeaderDialog(function(){
						// localStorage.lastLikeNotice = self.time.getTime();
					// });
				}
			} else {
				self.sendLikesRequest(login);
			}
			
			$.extend(true, self.projectLikes, self.recentLikes);

			self.handleLikesCount(self.projectLikes);
		}
	});

	$(".catalogue-item-icons__icon-heart").on('click', function(e) {
		e.preventDefault();
		var id = $(this).closest('.catalogue-item').attr('data-id');
		if ($(this).hasClass('active')) {
			$(this).removeClass('active');
			self.recentLikes[id] = false;
			if ($(this).closest('.section--favorites').length) {
				$(this).closest('.catalogue-item').remove();
			}
		} else {
			$(this).addClass('active');
			self.recentLikes[id] = true;
		}

		localStorage.recentLikes = JSON.stringify(self.recentLikes);
		if (!userLoggedIn) {
			if (!localStorage.lastLikeNotice || self.time.getTime()-localStorage.lastLikeNotice > 24*3600*100) {
				// $('body').append("<div class='header-dialog'><b>Aby wyświetlić ulubione projekty musisz się zalogować.</b> Twoje preferencje zostaną zapamiętane do tego czasu.</div>");
				// self.handleHeaderDialog(function(){
					// localStorage.lastLikeNotice = self.time.getTime();
				// });
			}
		} else {
			self.sendLikesRequest(login);
		}
		
		$.extend(true, self.projectLikes, self.recentLikes);

		self.handleLikesCount(self.projectLikes);
	});

	$(".cart-like").on('click', function(e) {
		e.preventDefault();
		var id = $(this).closest('.cart-positions-table-row').attr('data-id');
		if ($(this).closest('.cart-positions-table-row').hasClass('like-active')) {
			$(this).closest('.cart-positions-table-row').removeClass('like-active');
			self.recentLikes[id] = false;
		} else {
			$(this).closest('.cart-positions-table-row').addClass('like-active');
			self.recentLikes[id] = true;
		}

		localStorage.recentLikes = JSON.stringify(self.recentLikes);
		if (!userLoggedIn) {
			if (!localStorage.lastLikeNotice || self.time.getTime()-localStorage.lastLikeNotice > 24*3600*100) {
				// $('body').append("<div class='header-dialog'><b>Aby wyświetlić ulubione projekty musisz się zalogować.</b> Twoje preferencje zostaną zapamiętane do tego czasu.</div>");
				// self.handleHeaderDialog(function(){
					// localStorage.lastLikeNotice = self.time.getTime();
				// });
			}
		} else {
			self.sendLikesRequest(login);
		}
		
		$.extend(true, self.projectLikes, self.recentLikes);

		self.handleLikesCount(self.projectLikes);
	});

	self.toggleProjectsHeart();
};

Favorites.prototype.handleLikesCount = function(likes) {
	var self = this;
	var likesCount = [];

	$.each(likes, function(i, v) {
		if (v === true) {
			likesCount.push(i);
		}
	});

	$('.navbar-like').find('span.counter').text(likesCount.length);
	$('.liked_products').find('span.counter').text(likesCount.length);
    if (!likesCount.length && $('.favorites-content').children().length == 0)
		$('.favorites-empty').addClass('-active');
	// if (likesCount.length === 0) {
	// 	$('.liked_products').find('span.counter').addClass('-empty');
	// 	$('.header__icon.likes').find('span.counter').addClass('-empty');
	// } else {
	// 	$('.header__icon.likes').find('span.counter').removeClass('-empty');
	// 	$('.liked_products').find('span.counter').removeClass('-empty');
	// }
	// setTimeout(function() {
	// 	$('.header__icon.likes').find('span.counter').addClass('-animating');
	// }, 1000);
};

/*Favorites.prototype.handleHeaderDialog = function(clickCallback) {
	var self = this;
	var content = $('.header-dialog').html();
	var timeout = $('.header-dialog').attr('data-timeout')|0;
	var dialog = $('header .dialog');
	dialog.find('.content').empty().append(content);
	dialog.delay(600).slideDown(500);
	dialog.find('.close').click(function() {
		dialog.slideUp();
		if (clickCallback)
			clickCallback();
	});
	// if (timeout) {
		// dialog.find('.close').addClass('timer').attr('data-after',timeout);
		// for (i=timeout;i>=0;i--) {
		// 	(function(index,time) {
		// 		setTimeout(function() {
		// 			dialog.find('.close').attr('data-after',index);
		// 		},time*1000);
		// 	})(timeout-i,i);
		// 	if (i == timeout) {
		// 		setTimeout(function() {
		// 			dialog.find('.close').click();
		// 		},i*1000);
		// 	}
		// }
	// }
	// $('.header-dialog').remove();
};*/

/* helpers */
function isEmptyObject(obj) {
	for (var name in obj) {
		return false;
	}
	return true;
}